import React from 'react';
import CaregiverForm from './CaregiverForm';
import PatientForm from './PatientForm';



class Step1 extends React.Component{
    constructor(){
        super()
        this.state = {
            selectValue: 'patient',
            step: 1
        }
        this.showStep1 = this.showStep1.bind(this);
        this.showStep2 = this.showStep2.bind(this);
    }
    handleChange(e){
        this.setState({
            selectValue: e.target.value
        })
    }
    showStep1(){
        this.setState({
            step: 1
        })
    }
    showStep2(){
        this.setState({
            step: 2
        })
    }
    render(){
        const passed = this.state.step !== 1? "passed" : "";
        return(
            <div className="step-1">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-8 offset-sm-2">
                            <div className="step-indicator">
                                <div className={`indicator-1  ${passed} ${this.state.step === 1? 'active' : ''}`}>Step 1 - Basic Information<i className="fa fa-play"></i></div>
                                <div className={`indicator-2 ${this.state.step === 2? 'active' : ''}`}>Step 2 - Other information</div>
                            </div>
                            {this.state.selectValue === "Caregiver" &&
                                <div className="caregiver-indicator"></div>
                            }
                        </div>
                    </div>        
                    <div className="row">
                        <div className="col-sm-8 offset-sm-2">
                            <div className="form-card">
                                {this.state.step === 1 && <h4>Add New Patient or Caregiver</h4>}
                                {this.state.step === 2 && <h4>Add Treatment Information</h4>}
                                <div className="form">
                                    {this.state.step === 1 &&
                                        <label>
                                            Select user category
                                            <select onChange={this.handleChange.bind(this)}>
                                                <option value="patient">Patient</option>
                                                <option value="caregiver">Caregiver</option>
                                            </select>
                                        </label>
                                    }
                                {this.state.selectValue === "patient" &&
                                    <PatientForm 
                                        userType={this.state.selectValue} 
                                        step={this.state.step} 
                                        handleStep1={this.showStep1} 
                                        handleStep2={this.showStep2} />
                                }
                                {this.state.selectValue === "caregiver" &&
                                    <CaregiverForm userType={this.state.selectValue}/>
                                }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Step1;


// WEBPACK FOOTER //
// ./src/components/addUser/Step1.js